import React, { useEffect, useState } from 'react';
import { Login } from '../../components/Login';
import fire from '../../utils/firebase/firebase';
import { useStore } from '../../store/Store';
import './style.css';
import 'bootstrap/dist/js/bootstrap';
import { AdminHeader } from './AdminHeader';
import { AdminProgramas } from './AdminProgramas';
import { AdminProgramaForm } from './AdminProgramaForm';
import { setUserLoged } from '../../store/ActionAdmin';
import { SWITCH_ADMIN_MENU } from '../../store/ActionTypes';
import PageLoading from '../../components/PageLoading';

export const Admin = () => {
  const {
    state: { user, menuAdminActivo },
    dispatch
  } = useStore();

  const [logiConfirmed, setLoginConfirmed] = useState(false);

  // const currentUser = fire.auth().currentUser;

  useEffect(() => {
    fire.auth().onAuthStateChanged(currentUser => {
      if (currentUser) {
        dispatch({ type: SWITCH_ADMIN_MENU, payload: 'programas' });
        setUserLoged(dispatch, currentUser);
        setLoginConfirmed(true);
      } else {
        setLoginConfirmed(true);
      }
    });
  }, []);

  const switchMenuAdminActivo = () => {
    switch (menuAdminActivo) {
      case 'programas':
        return <AdminProgramas />;
      case 'editPrograma':
        return <AdminProgramaForm />;
      default:
        break;
    }
  };

  const fillContentAdmin = () => {
    if (!user) return <Login />;

    return (
      <React.Fragment>
        <AdminHeader />
        {switchMenuAdminActivo()}
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      {!logiConfirmed ? <PageLoading /> : fillContentAdmin()}
    </React.Fragment>
  );
};
